import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { getPublications } from "../../lib/api";

export default function Publications() {
  const [pubs, setPubs] = useState([]);

  useEffect(() => {
    getPublications().then(setPubs).catch(() => {});
  }, []);

  return (
    <section id="publications" className="relative py-24 md:py-36 bg-surface/40 border-y border-gold/10" data-testid="publications-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="max-w-3xl">
            <span className="text-xs uppercase tracking-[0.25em] text-gold">Research & Publications</span>
            <h2 className="font-serif text-4xl md:text-6xl font-light mt-4 leading-tight text-foreground">
              Peer-reviewed <span className="text-gradient-gold italic">by design.</span>
            </h2>
          </div>
        </Reveal>

        <div className="mt-14 border-t border-gold/10">
          {pubs.map((p, i) => (
            <Reveal key={i} delay={(i % 3) * 0.05}>
              <a
                href={p.link}
                target="_blank"
                rel="noreferrer"
                data-testid={`publication-${i}`}
                className="group grid grid-cols-12 gap-4 items-center py-8 border-b border-gold/10 hover:bg-card/60 transition-colors duration-300 px-2 -mx-2"
              >
                <div className="col-span-12 md:col-span-2">
                  <span className="text-xs uppercase tracking-[0.15em] text-gold/70">{p.type}</span>
                  <p className="text-sm text-muted-foreground mt-1">{p.year}</p>
                </div>
                <div className="col-span-11 md:col-span-9">
                  <h3 className="font-serif text-xl md:text-2xl text-foreground group-hover:text-gold transition-colors leading-snug">
                    {p.title}
                  </h3>
                  <p className="text-sm text-muted-foreground mt-2 italic">{p.venue}</p>
                </div>
                <div className="col-span-1 flex justify-end">
                  <ArrowUpRight size={22} className="text-gold/50 group-hover:text-gold group-hover:rotate-45 transition-all duration-300" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
